import React from "react";
import { FormattedMessage } from "react-intl";

import { Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "~/common/redesign-v1";
import { Bell } from "~/common/redesign-v1/icons";

export function RedesignEnablePushModal({ open, busy, onEnable, onDismiss }: { open: boolean; busy: boolean; onEnable(): void; onDismiss(): void }) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onDismiss()}>
      <DialogContent data-testid="rd-pwa-push-primer-modal" className="tw-max-w-sm tw-items-center tw-text-center">
        <div className="tw-flex tw-size-16 tw-items-center tw-justify-center tw-rounded-full tw-bg-muted">
          <Bell className="tw-size-7 tw-text-foreground" />
        </div>
        <DialogHeader>
          <DialogTitle>
            <FormattedMessage id="redesign.pwa.push_primer.title" />
          </DialogTitle>
          <DialogDescription>
            <FormattedMessage id="redesign.pwa.push_primer.body" />
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" className="tw-w-full" data-testid="rd-pwa-push-primer-cta" disabled={busy} onClick={onEnable}>
            <FormattedMessage id="redesign.pwa.push_primer.cta" />
          </Button>
          <Button type="button" variant="ghost" className="tw-w-full" data-testid="rd-pwa-push-primer-dismiss" onClick={onDismiss}>
            <FormattedMessage id="redesign.pwa.push_primer.dismiss" />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
